import InquiryApi from '@apis/inquiry/InquiryApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { InquiryCommentRequest } from '@models/inquiry';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

function useCommentInquiry(inquiryId: string) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { pop } = useFlow();
  const { mutate } = useMutation({
    mutationFn: (request: InquiryCommentRequest) => InquiryApi.createComment(
      inquiryId,
      request,
    ),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: queries.inquiry._def });
      toast.success('추가 문의가 등록되었습니다.');
      pop(2);
    },
    onError(e: AxiosError<ErrorResponse>) {
      toast.error(e.response?.data.message || '추가 문의에 실패했습니다.');
    },
  });
  return (content: string, fileUrls: string[]) => {
    mutate({ content, fileUrls });
  };
}

export default useCommentInquiry;
